import Vue from "vue"

import i18n from "@/modules/i18n"
import ExpendableFaq from "./expendable-faq"
import store from "@/store/"
import "@/modules/load-plans"

const init = () => {
  const el = document.querySelector("#vue-expendable-faq")

  if (!el) {
    return
  }

  new Vue({
    name: "ExpendableFaq",
    el,
    store,
    i18n,
    render: (h) => h(ExpendableFaq)
  })
}

init()
